module.exports = __webpack_public_path__ + "static/media/Ship.05894812.png";